import React, { useState, useContext, useEffect } from 'react'
import { Link, useSearchParams } from 'react-router-dom'

import ProfileSection from './Profile'
import AddressSection from './Address'
import ChangePassword from './ChangePassword'
import Notification from './Notification'
import MyOrder from './MyOrder'
import AddNewAddress from "../../components/AddNewAddress";
import JWTContext from '../../context/JWTContext';
import { useMobile } from '../../hooks/mediaHooks'

const Account = () => {
    const { logout: logoutAccount } = useContext(JWTContext);
    const [addressId, setAddressId] = useState(null);

    const isMobile = useMobile();

    const [searchParams, setSearchParams] = useSearchParams();
    const keyword = searchParams.get('t');

    let [active, setActive] = useState(false);
    let [activeMenu, setActiveMenu] = useState(0);

    let sidebarController = () => {
        setActive(!active);
    };

    const handleAddressEnumChange = (add) => {
        setActiveMenu(add);
        setAddressId(null);
    }

    useEffect(() => {
        if (keyword) {
            if (keyword === "order") {
                setActiveMenu(3);
            }
        }
    }, [keyword]);

    return (
        <section className="account py-40">
            <div className="container container-md">
                <div className="row">
                    <div className="col-lg-3 col-md-3 col-12">
                        {
                            isMobile ? (
                                <div className='d-flex gap-10 w-100 flex-nowrap px-20 pb-20' style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
                                    <button type="button" className={`btn ${activeMenu === 0 ? "bg-main-one-600 text-white" : "bg-white text-main-one-600"} flex-shrink-0 me-2 px-10`} onClick={() => setActiveMenu(0)}>
                                        Profile
                                    </button>
                                    <button type="button" className={`btn ${activeMenu === 1 ? "bg-main-one-600 text-white" : "bg-white text-main-one-600"} flex-shrink-0 me-2 px-10`} onClick={() => setActiveMenu(1)}>
                                        Address
                                    </button>
                                    <button type="button" className={`btn ${activeMenu === 2 ? "bg-main-one-600 text-white" : "bg-white text-main-one-600"} flex-shrink-0 me-2 px-10`} onClick={() => setActiveMenu(2)}>
                                        Change Password
                                    </button>
                                    <button type="button" className={`btn ${activeMenu === 3 ? "bg-main-one-600 text-white" : "bg-white text-main-one-600"} flex-shrink-0 me-2 px-10`} onClick={() => setActiveMenu(3)}>
                                        My Order
                                    </button>
                                    <button type="button" className={`btn bg-white text-main-one-600 flex-shrink-0 me-2 px-10`} onClick={() => logoutAccount()}>
                                        Logout
                                    </button>
                                </div>
                            ) : (
                                <div className={`shop-sidebar`}>
                                    <button
                                        onClick={sidebarController}
                                        type="button"
                                        className="shop-sidebar__close d-lg-none d-flex w-32 h-32 flex-center border border-gray-100 rounded-circle hover-bg-main-one-600 position-absolute inset-inline-end-0 me-10 mt-8 hover-text-white hover-border-main-one-600"
                                    >
                                        <i className="ph ph-x" />
                                    </button>
                                    <div className="shop-sidebar__box py-32 border-end border-gray-100 mb-32">
                                        <h6 className="text-xl pb-10 mb-10 d-flex align-items-center gap-12">
                                            <i class="ph ph-user-circle"></i> Account
                                        </h6>
                                        <ul className="max-h-540 overflow-y-auto scroll-sm">
                                            <li className="mb-24" onClick={() => setActiveMenu(0)}>
                                                <div className="form-check common-check common-radio ">
                                                    <label className={`form-check-label hover-text-main-one-600 ${activeMenu === 0 && "text-main-one-600"}`}>
                                                        Profile
                                                    </label>
                                                </div>
                                            </li>
                                            <li className="mb-24" onClick={() => setActiveMenu(1)}>
                                                <div className="form-check common-check common-radio">
                                                    <label className={`form-check-label hover-text-main-one-600 ${activeMenu === 1 && "text-main-one-600"}`}>
                                                        Address
                                                    </label>
                                                </div>
                                            </li>
                                            <li className="mb-24" onClick={() => setActiveMenu(2)}>
                                                <div className="form-check common-check common-radio">
                                                    <label className={`form-check-label hover-text-main-one-600 ${activeMenu === 2 && "text-main-one-600"}`}>
                                                        Change Password
                                                    </label>
                                                </div>
                                            </li>
                                        </ul>
                                        <h6 onClick={() => setActiveMenu(3)} style={{ cursor: "pointer" }} className={`text-xl pb-10 mb-10 d-flex align-items-center gap-12 hover-text-main-one-600 ${activeMenu === 3 && "text-main-one-600"}`}>
                                            <i class="ph ph-invoice"></i> My Order
                                        </h6>
                                        {/* <h6 onClick={() => setActiveMenu(4)} style={{ cursor: "pointer" }} className={`text-xl pb-10 mb-10 d-flex align-items-center gap-12 hover-text-main-one-600 ${activeMenu === 4 && "text-main-one-600"}`}>
                                            <i class="ph ph-bell"></i> Notification
                                        </h6> */}
                                        <h6 onClick={() => logoutAccount()} style={{ cursor: "pointer" }} className={`text-xl pb-10 mb-10 d-flex align-items-center gap-12 text-main-one-600`}>
                                            <i class="ph ph-sign-out"></i> Logout
                                        </h6>
                                    </div>
                                </div>
                            )
                        }
                        
                    </div>
                    <div className="col-lg-9 col-md-9 col-12">
                        {
                            activeMenu === 0 &&
                            <ProfileSection />
                        }
                        {
                            activeMenu === 1 &&
                            <AddressSection addressEnumChange={handleAddressEnumChange} onEdit={(addressId) => {
                                setAddressId(addressId);
                                setActiveMenu(5);
                            }} />
                        }
                        {
                            activeMenu === 2 &&
                            <ChangePassword />
                        }
                        {
                            activeMenu === 3 &&
                            <MyOrder />
                        }
                        {/* {
                            activeMenu === 4 &&
                            <Notification />
                        } */}
                        {
                            activeMenu === 5 &&
                            <AddNewAddress addressId={addressId} onFinish={
                                () => {
                                    setActiveMenu(1);
                                    setAddressId(null);
                                }
                            } />
                        }
                        {/* {
                            activeMenu === 3 &&
                            <MyOrder />
                        }
                        {
                            activeMenu === 4 &&
                            <Notification />
                        } */}
                    </div>
                </div>
            </div>
        </section>

    )
}

export default Account